<template>
  <el-drawer direction="rtl" v-model="visible" title="反馈详情" size="800px" :before-close="handleClose">
    <el-descriptions v-if="addRow" :column="1" border>
      <el-descriptions-item label-class-name="w100" label="反馈用户" >
        <user-box :detail="addRow"></user-box>
      </el-descriptions-item>
      <el-descriptions-item label-class-name="w100" label="反馈内容" >
        <div v-html="addRow.content"></div>
        <image-show v-if="addRow.picList&&addRow.picList.length>0"  :images="addRow.picList.map(item=>filePath+item.url)"></image-show>
      </el-descriptions-item>
      <el-descriptions-item label-class-name="w100" label="反馈时间" >
        <span>{{addRow.createTime}}</span>
      </el-descriptions-item>
      <el-descriptions-item label-class-name="w100" label="处理时间" >
        <span>{{addRow.handleTime}}</span>
      </el-descriptions-item>
      <el-descriptions-item label-class-name="w100" label="状态" >
        <span>{{addRow.status?"已处理":"待处理"}}</span>
      </el-descriptions-item>
    </el-descriptions>
    <template #footer>
          <span class="dialog-footer">
            <el-button @click="handleClose">关闭</el-button>
          </span>
    </template>
  </el-drawer>
</template>

<script>
import FormItemRule from "/src/components/el/form-item-rule";
import UserBox from "@view/components/user-box.vue";
import ImageShow from "@/components/base/image-show.vue";


export default {
  name: "feedback-detail",
  components: {ImageShow, UserBox, FormItemRule},
  data() {
    return {
      visible: false,
      addRow: {}
    }
  },
  mixins: [tableBase],
  methods: {
    handleClose() {
      this.visible = false;
    },
    open(row) {
      this.addRow = this.copyObj(row);
      this.visible = true;
    },
  },
  mounted() {

  }
}
</script>

<style lang="less" scoped>

</style>
